import React from 'react'
import { LEGACY_TEAM_ACCESS } from 'domains/legacy-feature/access'
import { protectRoute } from 'components/route-access/route-access'
import PaymentReportsPage from 'domains/dashboard-migration/payment-reports-page'

// Reuse the existing pages, URLs and access rules when regrouping the sidebar.
const legacyPage = (view, team) => ({
  ...view,
  ...LEGACY_TEAM_ACCESS[team],
  component: protectRoute({ ...view, ...LEGACY_TEAM_ACCESS[team], component: (props) => React.createElement(view.component, { ...props, mainTitle: `Legacy Features / ${team}` }) }).component
})

const legacyGroup = (name, views) => ({
  collapse: true,
  ...LEGACY_TEAM_ACCESS[name],
  name,
  miniName: name[0],
  state_key: `legacy_features_${name.toLowerCase()}_collapse`,
  views: views.map((view) => legacyPage(view, name))
})

const organizeSidebarRoutes = (routes) => {
  const sales = routes.find((route) => route.state_key === 'sales_team_collapse')
  const finance = routes.find((route) => route.state_key === 'finance_team_collapse')
  const marketing = routes.find((route) => route.state_key === 'marketing_migration_collapse')
  const setting = routes.find((route) => route.state_key === 'setting_collapse')
  const operations = routes.find((route) => route.state_key === 'legacy_operations_collapse')
  const salesPaths = [ '/sales/user-histories', '/sales/legacy-appraisals' ]
  const reportPath = '/setting/reportings'
  const invoicePath = '/finance/invoice-archive'
  const cart = operations.views.find((view) => view.path === '/legacy-operations/carts')
  const reporting = setting.views.find((view) => view.path === reportPath)
  const operationPaths = [ 'outbounds', 'pickups', 'pickup-products', 'tanda-keluars', 'transits' ]
  const legacyFeatures = {
    ...operations,
    name: 'Legacy Features',
    state_key: 'legacy_features_collapse',
    views: [
      legacyGroup('Sales', [ cart, ...salesPaths.map((path) => sales.views.find((view) => view.path === path)) ]),
      legacyGroup('Marketing', marketing.views),
      legacyGroup('Finance', finance.views.filter((view) => view.path === invoicePath)),
      legacyGroup('Operations', operationPaths.map((path) => {
        const view = operations.views.find((item) => item.path === `/legacy-operations/${path}`)
        return path === 'pickups' ? { ...view, name: 'Pickups' } : view
      }))
    ]
  }

  const teams = routes.filter((route) => ![ marketing, setting, operations ].includes(route)).map((route) => {
    if (route === sales) return { ...route, views: route.views.filter((view) => !salesPaths.includes(view.path)) }
    if (route === finance) return {
      ...route,
      views: [ ...route.views.filter((view) => view.path !== invoicePath), {
        collapse: true,
        name: 'Reporting',
        miniName: 'R',
        state_key: 'finance_reporting_collapse',
        views: [
          { ...reporting, name: 'Inventory', miniName: 'I' },
          protectRoute({ path: '/finance/report-payments', name: 'Payment', miniName: 'P', component: PaymentReportsPage, layout: '/app', allowedRoles: [ 'owner', 'admin', 'finance' ], allowedEmails: [ 'mifta.belleandkate@gmail.com', 'sweta.sabilillah.belleandkate@gmail.com' ] })
        ]
      } ]
    }
    return route
  })
  const sortedSetting = {
    ...setting,
    views: setting.views.filter((view) => view.path !== reportPath).slice().sort((left, right) => left.name.localeCompare(right.name, 'en'))
  }

  return [ ...teams, legacyFeatures, sortedSetting ]
}

export default organizeSidebarRoutes
